// extracted by mini-css-extract-plugin
export default {"listLoader":"infiniteScroll_listLoader__79+BN","loaderWrapper":"infiniteScroll_loaderWrapper__9ahgU"};